import { FC } from 'react';

type Props = {
	label?: string;
	icon?: string;
};

const ApartmentsDetailsAmenitiesElement: FC<Props> = ({ label, icon }) => {
	return (
		<div className='w-fit px-3 py-2 rounded-full flex gap-1.5 bg-popover-50'>
			<img
				src={icon}
				alt='amenity icon'
				className='size-5'
			/>
			<span>{label ?? ''}</span>
		</div>
	);
};

export default ApartmentsDetailsAmenitiesElement;
